import React from 'react';

import styled from 'styled-components';

import Button from 'components/lib/Button';

import { SHOP_DATA_TABS_GENERAL_KEY } from './constants';
import { hasPendingDocumentAnalysis } from './documents/helpers';
import { SHOP_DATA_DEFAULT_MENU_ITEM_INDEX, SHOP_DATA_MODAL_LIVING_TYPE_SIDEBAR_MENU_ITEMS } from './menus';
import { useShopDataModalContext } from './ShopDataModalContext';
import { SNAPSHOT_SELECTOR_SELECTION } from '../../common/Snapshot/editor/constants';
import { useAppSelector } from '../../store/hook';

const Container = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  padding: 20px 28px 20px 29.5px;
  background-color: var(--white);
  border-top: 1px solid var(--line-gray);
`;

const Actions = styled.div`
  display: flex;
  gap: 10px;
`;

const StyledButton = styled(Button)`
  padding: 10px 43px 10px 44px;
`;

const ShopDataModalFooter = () => {
  const livingTypes = useAppSelector((state) => state.global.livingTypes);
  const {
    currentTab,
    dataStatus,
    currentStep,
    validateData,
    handleSubmit,
    requestLoading,
    handleNavigation,
    currentData,
  } = useShopDataModalContext();

  const handleSave = async () => {
    validateData(
      () => {
        handleSubmit();
      },
      () => {
        // Does Nothing
      }
    );
  };

  const disabledPreviousButton =
    currentTab === SHOP_DATA_TABS_GENERAL_KEY && currentStep === SHOP_DATA_DEFAULT_MENU_ITEM_INDEX;
  const hasCleanData = Object.values(dataStatus).every((item: any) => !item?.dirty);
  const documentsAnalysisPending = hasPendingDocumentAnalysis(currentData?.documents ?? []);
  const hideNextButton =
    livingTypes.length === Number(currentTab) &&
    SHOP_DATA_MODAL_LIVING_TYPE_SIDEBAR_MENU_ITEMS.length - 1 === currentStep;

  return (
    <Container>
      <Actions>
        <StyledButton
          disabled={disabledPreviousButton}
          onClick={() => handleNavigation(-1)}
          data-test-id="sd-modal-previous-btn"
        >
          Previous Step
        </StyledButton>
        {!hideNextButton && (
          <StyledButton
            type="primary"
            disabled={hideNextButton}
            onClick={() => handleNavigation(1)}
            data-test-id="sd-modal-next-btn"
          >
            Next
          </StyledButton>
        )}
        {hideNextButton && (
          <StyledButton
            type="primary"
            disabled={hasCleanData || requestLoading || documentsAnalysisPending}
            loading={requestLoading}
            onClick={handleSave}
            data-test-id="sd-modal-save-&-close-btn"
          >
            Save & Close
          </StyledButton>
        )}
      </Actions>
    </Container>
  );
};

export default ShopDataModalFooter;
